import { useContext, useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { AppConstantsContext, UserContext } from '../../../../context';
import { TranscriptionDialogContext } from '../../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import {
  backendService,
  TrackingCategory,
  trackingService,
  TrackingTranscriptionParams,
} from '../../../../services';
import type { Step } from './TranscriptionDialog.config';
import { HELPER_TEXT, STEP_TITLE, STEPS } from './TranscriptionDialog.config';
import TranscriptionDialogWrapper from './TranscriptionDialogWrapper';
import ComposerTitle from './steps/ComposerTitle';

export interface TranscriptionDialogScanProps {
  open: boolean;
  handleClose: () => void;
  handleProcessing?: (processing: number) => void;
  handleResolve?: (jobId: string, useTickets: boolean) => void;
  location?: (typeof TrackingTranscriptionParams.location)['songbook' | 'wp' | 'nav'];
}
const TranscriptionDialogScan: React.FC<TranscriptionDialogScanProps> = ({
  open,
  handleClose,
  handleProcessing,
  handleResolve,
  location,
}) => {
  const { t } = useTranslation();
  const { jobType } = useContext(AppConstantsContext);
  const { apriori, file, reset, source } = useContext(TranscriptionDialogContext);
  const { user } = useContext(UserContext);
  const [submitting, setSubmitting] = useState(false);

  const steps: Step[] = [STEPS.COMPOSER_TITLE];
  const [currentStep, setCurrentStep] = useState<Step>(steps[0]);

  const onSubmit = (useTickets: boolean) => {
    setSubmitting(true);
    const trackingValues = {
      type: useTickets
        ? TrackingTranscriptionParams.type.full
        : TrackingTranscriptionParams.type.free,
      location,
      input: TrackingTranscriptionParams.input.scan,
    };
    trackingService.valueObjectEvent<{ type: string; location: string; input: string }>(
      TrackingCategory.Transcription,
      TrackingTranscriptionParams.action.create,
      { ...trackingValues },
    );

    return backendService.transcribeFile(
      file,
      useTickets,
      {
        apriori,
      },
      source,
      jobType,
      user?.token,
      (perc) => {
        handleProcessing(perc);
      },
      (jobId) => {
        handleResolve(jobId.toString(), useTickets);
      },
    );
  };

  const onClickBack = () => {
    setCurrentStep(steps[steps.indexOf(currentStep) - 1]);
  };

  const handleCloseDialog = () => {
    reset();
    setSubmitting(false);
    trackingService.event(TrackingCategory.Transcription, 'action_wizard_close');
    handleClose();
  };

  return (
    <TranscriptionDialogWrapper
      submitting={submitting}
      open={open}
      handleClose={handleCloseDialog}
      handleBackClick={onClickBack}
      currentStep={steps.indexOf(currentStep)}
      numberOfSteps={steps.length}
      title={t(STEP_TITLE[currentStep])}
      helperText={t(HELPER_TEXT[currentStep])}
    >
      {/* {currentStep === STEPS.INSTRUMENT_ORDER && (
        <InstrumentOrder
          onSubmit={() => setCurrentStep(STEPS.COMPOSER_TITLE)}
          customSubmitButton={customSubmitButton}
        />
      )} */}
      {currentStep === STEPS.COMPOSER_TITLE && <ComposerTitle onSubmit={onSubmit} />}
    </TranscriptionDialogWrapper>
  );
};

export default TranscriptionDialogScan;
